import { Navigate, useLocation } from 'react-router-dom'
import { rememberPostLoginPath } from '@/storage/post-login-redirect'
import { useAccountStore } from '@/stores/account-store'
import { LoadingScreen } from '@/components/common/loading-screen'

/**
 * Entry redirect for `/` and legacy dashboard aliases. Decides on the session directly so
 * a signed-out visitor goes straight to /login instead of bouncing through /dashboard
 * (where AuthGuard would redirect them a frame later).
 */
export function HomeRedirect() {
  const location = useLocation()
  const session = useAccountStore((s) => s.session)
  const isAuthenticating = useAccountStore((s) => s.isAuthenticating)

  if (session) return <Navigate to="/dashboard" replace />
  if (isAuthenticating) return <LoadingScreen />
  rememberPostLoginPath(location)
  return <Navigate to="/login" replace />
}
